import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Cookie } from 'ng2-cookies';
import { SharedService } from '../shared';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { LandingHeaderLoaderStateService } from '../shared/services/landing-header-loader-state.service';

interface SectionConfig {
  component: string;
  order: number;
  htmlContent?: SafeHtml; // for dynamic HTML
}

export class DynamicContentModel {
  id: number;
  PageName: string;
  Catagory: string;
  Content: string;
  Occurance: number;
  visibility: string;
  icon: string;
  Description: string;
  SubTitle: string;
  CostData: string;
  Role_Visibility: string;
  Url_Path: string;
  Audience: string;
  background: string;
}
@Component({
    selector: 'app-landing-page-v4',
    templateUrl: './landing-page-v4.component.html',
    styleUrls: ['./landing-page-v4.component.css'],
    standalone: false
})

export class LandingPageV4Component implements OnInit, OnDestroy {
  public dynamicContentData : any = {}; 
  allVideos = []; // Array to hold video data
  carouselConfig: any = {};
  carouselLoader: boolean = true;
  isPageMediaLoading: boolean = true;
  isCarouselContentAvailable: boolean = false;
  sectionOrder: SectionConfig[] = [];
  public landing:string= 'landing';
  private isApiContentLoaded: boolean = false;
  private isCarouselReady: boolean = false;
  private isVideoReady: boolean = false;
  
  constructor( private route: Router, private sharedService: SharedService, private sanitizer: DomSanitizer, private landingHeaderLoaderStateService: LandingHeaderLoaderStateService) {
    const returnUrl = localStorage.getItem('returnUrl') || null;
    if (Cookie.get('codeCreated')!='') {
      Cookie.delete('codeCreated');
      if (returnUrl) {
        localStorage.removeItem('returnUrl'); 
      //   setTimeout(() => {
      //     this.route.navigateByUrl(returnUrl);
      // }, 300);
        }
     }
  }


  ngOnInit(): void {
    this.landingHeaderLoaderStateService.setLandingMediaLoading(true);
    this.getDynamicContentForLandingPage();
    sessionStorage.removeItem('groupList');
    sessionStorage.removeItem('segmentList');
    sessionStorage.removeItem('sublob');
    // this.getCaraouselConfiguration();
    // this.getVideoLibrary();
  }

  ngOnDestroy(): void {
    this.landingHeaderLoaderStateService.setLandingMediaLoading(false);
  }

  getDynamicContentForLandingPage() {
    const reqBody = {
      "PageName": "Landing Page"
    };
    this.sharedService.getDynamicContent(reqBody).subscribe({
      next: resp => {
        const data = resp.fieldData;
        const videoData = resp.videoData;

        // Field data logic
        if (data) {
          const serialized = JSON.stringify(data);
          const cached = sessionStorage.getItem('landingPageContent');
          if (cached !== serialized) {
            sessionStorage.setItem('landingPageContent', serialized);
            this.dynamicContentData = data;
          } else {
            this.dynamicContentData = cached ? JSON.parse(cached) : data;
          }

          const bodySection = this.dynamicContentData.Body_Section;

          this.sectionOrder = bodySection && Array.isArray(bodySection)
            ? bodySection
                .filter((item: any) => item.visibility === "True")
                .map((item: any) => ({
                  component: item.SubTitle,
                  order: item.Occurance,
                  htmlContent: item.Content ? this.sanitizer.bypassSecurityTrustHtml(item.Content) : undefined
                }))
                .sort((a: any, b: any) => a.order - b.order)
            : []; // Handle undefined or null Body_Section
        }

        // Video Library logic
          if (resp && videoData.length > 0) {
            this.allVideos = videoData.map((video: any) => this.normalizeVideoItem(video));
          }

        // carousel data logic
        // if (resp && resp.carouselData) {
        //   this.carouselConfig = resp.carouselData;
        //   this.isCarouselContentAvailable = true;
        // }
         if (resp?.carouselData) {
          this.carouselConfig = {
            ...resp.carouselData,
            slides: Array.isArray(resp.carouselData?.slides)
                ? resp.carouselData.slides.map((slide: any) => this.normalizeCarouselSlide(slide))
              : []
          };
           this.isCarouselContentAvailable = true;
        } else {
          this.carouselConfig = {};
          this.isCarouselContentAvailable = false;
        }

        this.resetMediaReadiness();
        this.isApiContentLoaded = true;
        this.carouselLoader = false;
        this.updatePageMediaLoader();
      },
      error: err => {
        this.isCarouselContentAvailable = false;
        this.carouselLoader = false;
        this.isApiContentLoaded = true;
        this.isCarouselReady = true;
        this.isVideoReady = true;
        this.updatePageMediaLoader();
        console.log("Error while loading data", err);
      }
    });
}

  onCarouselReady(): void {
    this.isCarouselReady = true;
    this.updatePageMediaLoader();
  }

  onVideoLibraryReady(): void {
    this.isVideoReady = true;
    this.updatePageMediaLoader();
  }

  private resetMediaReadiness(): void {
    const visibleSections = new Set(
      (this.sectionOrder || []).map((section: SectionConfig) => String(section?.component || '').toLowerCase())
    );
    const shouldWaitForCarousel =
      visibleSections.has('carousel') &&
      this.isCarouselContentAvailable &&
      Array.isArray(this.carouselConfig?.slides) &&
      this.carouselConfig.slides.length > 0;
    const shouldWaitForVideos = visibleSections.has('video') && Array.isArray(this.allVideos) && this.allVideos.length > 0;

    this.isCarouselReady = !shouldWaitForCarousel;
    this.isVideoReady = !shouldWaitForVideos;
  }

  private updatePageMediaLoader(): void {
    this.isPageMediaLoading = !(this.isApiContentLoaded && this.isCarouselReady && this.isVideoReady);
    this.landingHeaderLoaderStateService.setLandingMediaLoading(this.isPageMediaLoading);
  }

  private stripTokenQueryParam(url: string): string {
    if (!url) return '';
    try {
      const parsed = new URL(url, environment.apiUrl);
      parsed.searchParams.delete('token');
      parsed.searchParams.delete('access_token');
      return parsed.toString();
    } catch {
      return url;
    }
  }

  private buildMediaUrl(url?: string | null): string {
    if (!url) {
      return '';
    }

    const trimmedUrl = url.trim();
    if (trimmedUrl.length === 0) {
    }

    const isAbsoluteUrl = /^https?:\/\//i.test(trimmedUrl);
    const normalizedUrl = isAbsoluteUrl
      ? trimmedUrl
      : `${environment.apiUrl}${trimmedUrl.startsWith('/') ? trimmedUrl : `/${trimmedUrl}`}`;

    // IMPORTANT: never attach tokens in query params.
    return this.stripTokenQueryParam(normalizedUrl);
  }

  private normalizeCarouselSlide(slide: any): any {
    const flattenedSlide = slide?.dataValues ? { ...slide.dataValues, ...slide } : slide;
    return {
      ...flattenedSlide
    };
  }

  private normalizeVideoItem(video: any): any {
    const flattenedVideo = video?.dataValues ? { ...video.dataValues, ...video } : video;
    const thumbnailPost = flattenedVideo?.thumbnailPost;
    const videoUrl = this.buildMediaUrl(flattenedVideo?.videoUrl);
    const vttUrl = this.buildMediaUrl(flattenedVideo?.vttUrl);

    return {
      ...flattenedVideo,
      // videoUrl: videoUrl, // Only use backend API path, never SAS URL
      videoUrl,
      vttUrl,
      thumbnailPost,
      is_playing: `${flattenedVideo?.is_playing}`.toLowerCase() === 'true'
    };
  }

}
